import { render, staticRenderFns } from "./CopyFirstAppointmentDialog.vue?vue&type=template&id=64d19e36&scoped=true&"
import script from "./CopyFirstAppointmentDialog.vue?vue&type=script&lang=js&"
export * from "./CopyFirstAppointmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./CopyFirstAppointmentDialog.vue?vue&type=style&index=0&id=64d19e36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d19e36",
  null
  
)

export default component.exports